// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

.card {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  z-index: 2;
}
.card .card-details {
  background: #fff;
  padding: 1rem;
  border-radius: 0.5rem;
  position: relative;
  display: flex;
  gap: 1rem;
  max-width: 500px;
}
.card svg.close-dialog-icon {
  position: absolute;
  padding: 0.3rem;
  border-radius: 50%;
  max-width: 1rem;
  max-height: 1rem;
  background-color: #eee;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}
.card svg.close-dialog-icon path {
  opacity: 1;
  fill: #000;
}
.card .product-image {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card .product-image img {
  max-width: 150px;
}
.card .product-details h1 {
  color: #3c3c3c;
  border-bottom: 0.5px solid #d8d8d8;
  padding-bottom: 10px;
  width: 100%;
  font-size: 20px;
  font-weight: 500;
}
.card .productDescription {
  max-height: 23vh;
  overflow-y: scroll;
}
.card .productDescription,
.card .price {
  font-size: 0.8rem;
  line-height: 1rem;
  margin: 1rem 0;
}
.card .price {
  font-weight: 500;
  margin: 0;
  display: flex;
  align-items: center;
}
.card .price svg {
  width: 0.8rem;
}
.card button.buy {
  background-color: #000;
  max-width: 100px;
  width: 100%;
  padding: 0.5rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  color: #fff;
  border-radius: 0.2rem;
  transition: 0.2s all ease-in-out;
}
.card button.buy:hover {
  transform: scale(1.1);
}
.card .products-buy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
}
.card .counter {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}
.card .counter .current-quantity {
  width: 20px;
  text-align: center;
}
.card .counter svg {
  width: 15px;
  background: #000;
  padding: 4px;
  cursor: pointer;
}
.card .counter svg path {
  fill: #fff;
}

.coming-soon-container {
  position: relative;
  border: 2px solid;
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
}
.coming-soon-container .coming-soon-content {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.coming-soon-container .coming-soon-content p {
  color: #ffffff;
}
.coming-soon-container .coming-soon-content p:nth-child(1) {
  font-size: 3.67vw;
  line-height: 3.67vw;
  font-weight: 500;
}
.coming-soon-container .coming-soon-content p:nth-child(2) {
  font-size: 0.91vw;
  line-height: 1.25vw;
  font-weight: 500;
  position: relative;
  top: 0.555vw;
}

.congratulations-heading .congrats-heading {
  margin-bottom: 1.11vw;
}
.congratulations-heading .congrats-heading h2 {
  font-weight: 400;
  line-height: 2.08vw;
  font-size: 2.08vw;
  color: #3a3a3a;
  padding-bottom: 0.35vw;
}
.congratulations-heading .congrats-heading p {
  font-weight: 400;
  line-height: 1.25vw;
  color: #3a3a3a;
  font-size: 0.9vw;
}
.congratulations-heading .congratulations-container {
  background: rgba(255, 255, 255, 0.8980392157);
  border-radius: 3px;
}
.congratulations-heading .congratulations-container .image-wrapper {
  padding: 1.39vw;
  border: 2px solid;
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
}
.congratulations-heading .congratulations-container .image-wrapper .demo-text {
  font-size: 1.04vw;
  font-weight: 500;
  line-height: 1.25vw;
  color: #ee3a24;
  padding: 0 1.11vw 1.11vw 0;
}
.congratulations-heading .congratulations-container .image-wrapper img {
  width: 67.37vw;
  height: 34.69vw;
}
.congratulations-heading .congratulations-container .btn-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.555vw 0;
}
.congratulations-heading .congratulations-container .btn-container button {
  border-radius: 3px;
  font-size: 0.9vw;
  font-weight: 500;
  line-height: 1.25vw;
  padding: 0.555vw 2.22vw;
  text-align: center;
}
.congratulations-heading .congratulations-container .btn-container .view-live {
  color: #ee3a24;
  border: 0.5px solid #ee3a24;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 0.755vw 4.22vw;
}
.congratulations-heading .congratulations-container .btn-container .go-live {
  background-color: #ee3a24;
  color: #fff;
  border: 0.5px solid #ee3a24;
}`, "",{"version":3,"sources":["webpack://./src/style/components/Card.scss"],"names":[],"mappings":"AAAA;;EAEE,YAAA;AACF;;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AAEF;AAAE;EACE,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;AAEJ;AACE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,MAAA;EACA,QAAA;EACA,+BAAA;AACJ;AACI;EACE,UAAA;EACA,UAAA;AACN;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAKE;EACE,cAAA;EACA,kCAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAKE;EACE,gBAAA;EACA,kBAAA;AAHJ;AAKE;;EAEE,iBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAKE;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAHJ;AAKI;EACE,aAAA;AAHN;AAOE;EACE,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,gCAAA;AALJ;AAOI;EACE,qBAAA;AALN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAPJ;AASI;EACE,WAAA;EACA,kBAAA;AAPN;AAUI;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AARN;AAUM;EACE,UAAA;AARR;;AAaA;EACE,kBAAA;EAOA,iBAAA;EACA,6GAAA;AAhBF;AAqBE;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAnBJ;AAoBI;EACE,cAAA;AAlBN;AAoBI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAlBN;AAoBI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAlBN;;AA0BE;EACE,qBAAA;AAvBJ;AAyBE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AAvBJ;AAyBE;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAvBJ;AAyBE;EACE,6CAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,eAAA;EACA,iBAAA;EACA,6GAAA;AAvBN;AA4BM;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;AA1BR;AA4BM;EACE,cAAA;EACA,eAAA;AA1BR;AA8BI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AA5BN;AA8BI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA5BN;AA8BI;EACE,cAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5BN;AA8BI;EACE,yBAAA;EACA,WAAA;EACA,2BAAA;AA5BN","sourcesContent":["html,\nbody {\n  height: 100%;\n}\n.card {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n  z-index: 2;\n\n  .card-details {\n    background: #fff;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    position: relative;\n    display: flex;\n    gap: 1rem;\n    max-width: 500px;\n  }\n\n  svg.close-dialog-icon {\n    position: absolute;\n    padding: 0.3rem;\n    border-radius: 50%;\n    max-width: 1rem;\n    max-height: 1rem;\n    background-color: #eee;\n    top: 0;\n    right: 0;\n    transform: translate(50%, -50%);\n\n    path {\n      opacity: 1;\n      fill: #000;\n    }\n  }\n\n  .product-image {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      max-width: 150px;\n    }\n  }\n\n  .product-details h1 {\n    color: #3c3c3c;\n    border-bottom: 0.5px solid #d8d8d8;\n    padding-bottom: 10px;\n    width: 100%;\n    font-size: 20px;\n    font-weight: 500;\n  }\n  .productDescription {\n    max-height: 23vh;\n    overflow-y: scroll;\n  }\n  .productDescription,\n  .price {\n    font-size: 0.8rem;\n    line-height: 1rem;\n    margin: 1rem 0;\n  }\n  .price {\n    font-weight: 500;\n    margin: 0;\n    display: flex;\n    align-items: center;\n\n    svg {\n      width: 0.8rem;\n    }\n  }\n\n  button.buy {\n    background-color: #000;\n    max-width: 100px;\n    width: 100%;\n    padding: 0.5rem 1.5rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    border: none;\n    color: #fff;\n    border-radius: 0.2rem;\n    transition: 0.2s all ease-in-out;\n\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n  .products-buy {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 0.5rem;\n  }\n\n  .counter {\n    display: flex;\n    align-items: center;\n    gap: 0.2rem;\n\n    .current-quantity {\n      width: 20px;\n      text-align: center;\n    }\n\n    svg {\n      width: 15px;\n      background: #000;\n      padding: 4px;\n      cursor: pointer;\n\n      path {\n        fill: #fff;\n      }\n    }\n  }\n}\n.coming-soon-container {\n  position: relative;\n  // background: url('../assests/images/coming-soon.png') no-repeat;\n  // height: 100%;\n  // -webkit-background-size: cover;\n  // -moz-background-size: cover;\n  // -o-background-size: cover;\n  // background-size: cover;;\n  border: 2px solid;\n  border-image-source: linear-gradient(\n    169.15deg,\n    rgba(255, 255, 255, 0.4) 0%,\n    rgba(238, 237, 237, 0.2) 96.79%\n  );\n  .coming-soon-content {\n    text-align: center;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    p {\n      color: #ffffff;\n    }\n    p:nth-child(1) {\n      font-size: 3.67vw;\n      line-height: 3.67vw;\n      font-weight: 500;\n    }\n    p:nth-child(2) {\n      font-size: 0.91vw;\n      line-height: 1.25vw;\n      font-weight: 500;\n      position: relative;\n      top: 0.555vw;\n    }\n  }\n}\n.congratulations-heading {\n  // margin-top: 1rem;\n\n  // margin-left: 2rem;\n  .congrats-heading {\n    margin-bottom: 1.11vw;\n  }\n  .congrats-heading h2 {\n    font-weight: 400;\n    line-height: 2.08vw;\n    font-size: 2.08vw;\n    color: #3a3a3a;\n    padding-bottom: 0.35vw;\n  }\n  .congrats-heading p {\n    font-weight: 400;\n    line-height: 1.25vw;\n    color: #3a3a3a;\n    font-size: 0.9vw;\n  }\n  .congratulations-container {\n    background: #ffffffe5;\n    border-radius: 3px;\n\n    .image-wrapper {\n      padding: 1.39vw;\n      border: 2px solid;\n      border-image-source: linear-gradient(\n        169.15deg,\n        rgba(255, 255, 255, 0.4) 0%,\n        rgba(238, 237, 237, 0.2) 96.79%\n      );\n      .demo-text {\n        font-size: 1.04vw;\n        font-weight: 500;\n        line-height: 1.25vw;\n        color: #ee3a24;\n        padding: 0 1.11vw 1.11vw 0;\n      }\n      img {\n        width: 67.37vw;\n        height: 34.69vw;\n      }\n    }\n\n    .btn-container {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin: 0.555vw 0;\n    }\n    .btn-container button {\n      border-radius: 3px;\n      font-size: 0.9vw;\n      font-weight: 500;\n      line-height: 1.25vw;\n      padding: 0.555vw 2.22vw;\n      text-align: center;\n    }\n    .btn-container .view-live {\n      color: #ee3a24;\n      border: 0.5px solid #ee3a24;\n      background-color: #fff;\n      display: flex;\n      align-items: center;\n      padding: 0.755vw 4.22vw;\n    }\n    .btn-container .go-live {\n      background-color: #ee3a24;\n      color: #fff;\n      border: 0.5px solid #ee3a24;\n    }\n  }\n}\n// @media only screen and (max-width: 550px) {\n//   .congratulations-heading{\n//     .congratulations-container{\n\n//       .btn-container{\n//           display: block;\n//         text-align: center;\n//       }\n//       .btn-container button{\n//         margin: 0.5rem auto;\n//       }\n//     }\n//   }\n// }\n// @media only screen and (max-width: 676px) {\n//   .congratulations-heading{\n//     .congratulations-container{\n\n//         .btn-container button{\n\n//           padding:8px 20px;\n\n//         }\n\n//     }\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
